<div class="info-popup-grp">
    <div class="info-popup-header">
        <button type="button" class="close btn-close-flash" (click)="closePopup()">
            <ng-container *ngIf="services.isMobile()">
              <svg xmlns="http://www.w3.org/2000/svg" width="11.535" height="11.536"
                viewBox="0 0 11.535 11.536">
                <g id="Group_10749" data-name="Group 10749" transform="translate(1.768 1.768)">
                  <g id="Group_10713" data-name="Group 10713">
                    <line id="Line_325" data-name="Line 325" x2="8" y2="8" fill="none" stroke="#004A63"
                      stroke-linecap="round" stroke-width="2.5" />
                    <line id="Line_326" data-name="Line 326" x1="8" y2="8" fill="none" stroke="#004A63"
                      stroke-linecap="round" stroke-width="2.5" />
                  </g>
                </g>
              </svg>
            </ng-container>
            <ng-container *ngIf="services.isDesktop()">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet"
                viewBox="0 0 17.657 17.657">
                <g id="Group_10714" data-name="Group 10714" transform="translate(-5694.015 -487.515)">
                  <g id="Group_10713" data-name="Group 10713" transform="translate(24.54 2.54)">
                    <line id="Line_325" data-name="Line 325" x2="12" y2="12"
                      transform="translate(5672.304 487.804)" fill="none" stroke="#004A63"
                      stroke-linecap="round" stroke-width="4" />
                    <line id="Line_326" data-name="Line 326" x1="12" y2="12"
                      transform="translate(5672.304 487.804)" fill="none" stroke="#004A63"
                      stroke-linecap="round" stroke-width="4" />
                  </g>
                </g>
              </svg>
            </ng-container>
          </button>
          <h2 *ngIf="title">{{title}}</h2>
    </div>
    <ng-template containerRef></ng-template>
</div>